  /**
 * Google Maps
 */

  // close modal
function closeModal(){
  jQuery('#modal').fadeOut(500, function() {
    // remove modal from DOM
    jQuery('#modal #modal-content').remove();
  });
}

var gmarkers = [];
var markers = [];

// define map width
function mapsWidth(){
  var viewportWidth = jQuery(window).width();
  if(viewportWidth > 600){
    var sidebar = jQuery('.side-bar').width();
    var body = jQuery('body').width();
    jQuery("#gmap").width(body - sidebar - 40);
  }
}

// change map width on window resize
jQuery(window).resize(function() {
  mapsWidth();
});

// initialize map
function initMap() {
  if (typeof locations === 'undefined'){
      return;
  }
  //initialize map
  //style config: https://mapstyle.withgoogle.com/
  var styles              = [
      {
        "featureType": "administrative.land_parcel",
        "elementType": "labels",
        "stylers": [
          {
            "visibility": "off"
          }
        ]
      },
      {
        "featureType": "landscape",
        "elementType": "labels.icon",
        "stylers": [
          {
            "visibility": "off"
          }
        ]
      },
      {
        "featureType": "landscape.natural",
        "elementType": "geometry.fill",
        "stylers": [
          {
            "color": "#e0eed4"
          }
        ]
      },
      {
        "featureType": "poi",
        "elementType": "labels",
        "stylers": [
          {
            "visibility": "off"
          }
        ]
      },
      {
        "featureType": "poi.attraction",
        "stylers": [
          {
            "visibility": "off"
          }
        ]
      },
      {
        "featureType": "poi.business",
        "stylers": [
          {
            "visibility": "off"
          }
        ]
      },
      {
        "featureType": "poi.park",
        "elementType": "labels.text",
        "stylers": [
          {
            "visibility": "off"
          }
        ]
      },
      {
        "featureType": "road",
        "elementType": "labels",
        "stylers": [
          {
            "visibility": "on"
          }
        ]
      },
      {
        "featureType": "road.arterial",
        "elementType": "labels",
        "stylers": [
          {
            "visibility": "off"
          }
        ]
      },
      {
        "featureType": "road.highway",
        "stylers": [
          {
            "visibility": "on"
          }
        ]
      },
      {
        "featureType": "road.highway",
        "elementType": "labels",
        "stylers": [
          {
            "visibility": "off"
          }
        ]
      },
      {
        "featureType": "road.highway.controlled_access",
        "stylers": [
          {
            "visibility": "on"
          }
        ]
      },
      {
        "featureType": "road.local",
        "elementType": "labels",
        "stylers": [
          {
            "visibility": "off"
          }
        ]
      },
      {
        "featureType": "water",
        "elementType": "labels",
        "stylers": [
          {
            "visibility": "off"
          }
        ]
      }
    ],
      args                = {styles : styles,
      fullscreenControl: false,
      mapTypeControl: false,
      minZoom: 11, 
      maxZoom: 15,
      },
      map                 = new google.maps.Map(document.getElementById('gmap'), args),
      bounds              = new google.maps.LatLngBounds(),
      infowindow          = new google.maps.InfoWindow(),
      marker,
      icon,
      i,
      windowContent;
      var clicked = false;

  for (i = 0; i < locations.length; i++) {
    if (locations[i].cat[0].slug !== 'paginas') { // exclude locations with category 'paginas'
  
    var icon = {
      url: locations[i].icon, // url
      scaledSize: new google.maps.Size(25, 25), // scaled size
      origin: new google.maps.Point(0,0), // origin
      anchor: new google.maps.Point(0, 0) // anchor
  };
  
    
      marker = new google.maps.Marker({
        position: {lat: parseFloat(locations[i].location.lat), lng: parseFloat(locations[i].location.lng)},
        icon: icon,
        title: locations[i].name,
        category: locations[i].cat[0].slug,
        tag: locations[i].tag,
        map: map,
        iterator: i
      });
      gmarkers.push(marker);
      bounds.extend(marker.position);
      google.maps.event.trigger('resize',map)


  // animate bounce on hover
  google.maps.event.addListener(marker, 'mouseover', (function(marker) {
    return function() {       
      marker.setAnimation(google.maps.Animation.BOUNCE);
      setTimeout(function(){ marker.setAnimation(null); }, 200);
    }
  })(marker));

  // add infowindow on hover
  google.maps.event.addListener(marker, 'mouseover', (function(marker) {
      return function() {        
        windowContent = '<h3>' + marker.title + '</h3>'
        infowindow.setContent(windowContent);
        infowindow.open(map, marker);
      }
  })(marker));

  // open modal on click
  google.maps.event.addListener(marker, 'click', (function(marker) {
    return function() {        
      openModal(marker.iterator);
    }
  })(marker));

  

// close infowindow on hover
  google.maps.event.addListener(marker, 'mouseout', (function(marker) {
    return function() {
        infowindow.close();
    }
  })(infowindow));
}

// set markers visible 
markersOn = function (){
  for (i = 0; i < gmarkers.length; i++) {
    gmarkers[i].setVisible(true);
  }  
}

// is category in array?
filterMarkers = function(val){
  for (i = 0; i < gmarkers.length; i++) {
    if (jQuery.inArray(gmarkers[i].category, val)>-1) {
      gmarkers[i].setVisible(true);
    } else{
      gmarkers[i].setVisible(false);
    }
  }
}

// filter checkbox
jQuery('input[type="checkbox"]').click(function(){
  // fill array with clicked checkbox
  var val = [];
  jQuery(':checkbox:checked').each(function(i){
    val[i] = jQuery(this).val();
  });
  
  //check if category is in array
  filterMarkers(val);

  // set everything visible when nothing is checked
  var notChecked = jQuery(':checkbox:checked').length;
  if (notChecked < 1){ 
    markersOn();
  };
  closeModal();
});

// tag filter
jQuery('.highlighted-item a').click(function(){
  // create array of tags
  tags = jQuery(this).data('tags').toString();
  filterByTag(tags);
  closeModal();
});

//create url for tag filter
var urlParams = new URLSearchParams(window.location.search);
if(urlParams.get("tags")){
  tags = urlParams.get("tags");
  filterByTag(tags);
}

// reset filters
function resetFilter(tags){
  jQuery.each(gmarkers, function(index, marker) {
    jQuery('input[type="checkbox"]').prop('checked', false); 
    marker.setVisible(true);
  });
}
// reset filter on logo click
jQuery('.side-bar img').click(function(event, marker){
  window.location = 'http://parkstad-transformeert.nl/';   
  // resetFilter();
});

//filter widgets by tags
function filterByTag(tags){
  if(tags){
    if(tags.length > 0){
      tags = tags.split(",");
    }
    // set each marker not visible
    jQuery.each(gmarkers, function(index, marker) {
      visible = false;
      // check if there are tags
      if(marker.tag.length > 0){
        // check if tag is in array
        jQuery.each(marker.tag, function(index, item) {
          for(var i = 0; i < tags.length; i++){
              if( item == tags[i] ){
                  visible = true;
              }
          }
        }); 
      }
      // set marker visibility (false or true)
      marker.setVisible(visible);
    });
  };
}

// fit markers
  if(locations.length > 1){
      map.fitBounds(bounds);
  }
}
}

// open modal
function openModal(index){
  console.log(index);

  var argsProjects = myData.locationsArray;
  console.log(argsProjects);
  var projectUrl = argsProjects[index].url;
  window.location.href = projectUrl;
  
}

jQuery(document).ready(function($) {
    mapsWidth();
  
  var home_url = window.location.origin;

  // close modal on click
  $("#modal-close").click(function(event) {
    event.preventDefault();
    if (document.referrer.includes("list-page.html")) {
      window.history.back();
    } else {
      window.location.href = home_url;
    }
  });
  
  

  // open mobile menu
  var hoogte = $('.side-bar').height();
  function openMobileMenu(){
    $('#mobile-menu').addClass('open');
    $('.side-bar').animate({top: 0 + 70}, 400);
  };

  // close mobile menu
  function closeMobileMenu(){
    $('#mobile-menu').removeClass('open');
    $('.side-bar').animate({top: -hoogte + 70}, 400);
  }

  // mobile menu
  $('#hamburger').click(function(event){
      event.preventDefault();
      if($('#mobile-menu').hasClass('open')){
        closeMobileMenu();
      }else{
        openMobileMenu();
      }
  });

// close mobile menu on window resize
  var width = $(window).width();
  $(window).on('resize', function() {
    if ($(this).width() != width) {
      if(width >= 600){
        $('.side-bar').css({top: 0});
      } else {
        $('.side-bar').css({top: -hoogte});
        $('#mobile-menu').removeClass('open');
      }
      width = $(this).width();
    }
  });

// close mobile menu on logo click
  $('#mobile-menu img').click(function(event){
    event.preventDefault();
    closeMobileMenu();
    window.location = 'http://parkstad-transformeert.nl/';       
  });

// close modal on logo click
  $('.side-bar img').click(function(event, marker){
    event.preventDefault();
    closeModal();
  });

// owl carousel side-bar
$('.highlight-wrapper .owl-carousel').owlCarousel({
  autoplay: true,
  autoplayTimeout: 7000,
  autoplayHoverPause: true,
  items: 1,
  loop: true,
  dots: true,
  animateIn: 'slideInDown', 
  animateOut: 'slideOutDown',
  mouseDrag: false,
  touchDrag: false,
  pullDrag: false,
})
$('#modal-content .owl-carousel').owlCarousel({
  autoplay: false,
  autoWidth: true,
  items: 1,
  loop: false,
  dots: true,
  nav: true,
  animateIn: 'slideInLeft', 
  animateOut: 'slideOutRight',
  mouseDrag: true,
  touchDrag: true,
  pullDrag: true,
})

});

function isFrontPage() {
  // Get the URL of the front page
  var frontPageUrl = window.location.protocol + '//' + window.location.host + '/';

  // Compare the current page URL with the front page URL
  return window.location.href === frontPageUrl;
}

document.getElementById('projectDropdown').addEventListener('click', function() {
  if (!isFrontPage()) {
    var frontPageUrl = window.location.protocol + '//' + window.location.host + '/';
    window.location.href = frontPageUrl;
  }

  document.getElementById('projectMap').classList.toggle('show');
  document.getElementById('map').classList.add('show');
  if (document.getElementById('list').classList.contains('show')) {
    document.getElementById('list').classList.toggle('show');
  }
  if (document.getElementById('meerInformatieLijst').classList.contains('show')) {
    document.getElementById('meerInformatieLijst').classList.toggle('show');
  }
});

document.getElementById('meerInformatie').addEventListener('click', function() {
  document.getElementById('meerInformatieLijst').classList.toggle('show');
});

document.getElementById('projectenLijst').addEventListener('click', function() {
  if (!isFrontPage()) {
    var frontPageUrl = window.location.protocol + '//' + window.location.host + '/';
    window.location.href = frontPageUrl;
  }
  document.getElementById('list').classList.add('show');
  if (document.getElementById('map').classList.contains('show')) {
    document.getElementById('map').classList.toggle('show');
  }
  if (document.getElementById('projectMap').classList.contains('show')) {
    document.getElementById('projectMap').classList.toggle('show');
  }
  if (document.getElementById('meerInformatieLijst').classList.contains('show')) {
    document.getElementById('meerInformatieLijst').classList.toggle('show');
  }
});



const searchBar = document.getElementById("searchBar");
if(searchBar){
searchBar.addEventListener("keyup", e => {
  const searchString = e.target.value;
  console.log(searchString);
});
}

